import { Injectable, Type } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ComponentRegistryService {
  private componentMap: { [key: string]: Type<any> } = {};

  registerComponent(selector: string, component: Type<any>) {
    this.componentMap[selector] = component;
  }

  getComponent(selector: string): Type<any> {
    return this.componentMap[selector];
  }
}
